// Globals
import { FC } from 'react';
import { useTranslation } from 'react-i18next';

// Components
import { Modal, ModalSize } from '@/components';
import { TrashIcon } from '@/icons';
import { Button } from '@/ui';
import { StyledButtons } from './DeleteFaqConfirmModalStyles';

type TDeleteFaqConfirmModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  isLoading?: boolean;
  title: string;
  description?: string;
  btnTitle?: string;
};

const DeleteFaqConfirmModal: FC<TDeleteFaqConfirmModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  isLoading,
  title,
  description,
  btnTitle,
}) => {
  const { t } = useTranslation();

  return (
    <Modal destroyOnClose title={title} onCancel={onClose} visible={isOpen} size={ModalSize.MEDIUM}>
      {description && <p>{description}</p>}
      <StyledButtons>
        <Button block onClick={onClose}>
          {t('cancel_btn')}
        </Button>
        <Button block type="primary" danger icon={<TrashIcon />} loading={isLoading} onClick={onConfirm}>
          {btnTitle || t('btn_faqs_delete')}
        </Button>
      </StyledButtons>
    </Modal>
  );
};

export default DeleteFaqConfirmModal;
